import { Box, Button, Checkbox, FormLabel, Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { Link, useNavigate } from 'react-router-dom';
import { selectImageUrl, selectLanguage, selectTranslations, toggleLang } from 'state/reducers/translation.reducers';
import { getTerms, getUserDetails, getUserPermission } from 'state/reducers/user.reducers';
import ColoredArea from 'components/ColoredArea';
import { pagesEnum } from 'constants/ui.constants';
import Articles from 'components/Articles/Articles';
import NoSideBarPage from 'components/NoSideBarPage';
import { FormHeadWithCheckbox } from 'theme/elements/Headers';
import { useEffect, useState } from 'react';
import { setContactApprovals } from 'services/user.services';
import { getMobile } from 'state/reducers/ui.reducers';
import { getUserName } from 'utils';
import { UserPermission } from 'constants/user.constants';

export default function WelcomeApp() {
  const isMobile = useAppSelector(getMobile);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const prefixField = 'page.dashboard.banner.';
  const [isAgreeTerms, setIsAgreeTerms] = useState(false);
  const [isAgreeMarketing, setIsAgreeMarketing] = useState(false);
  const isAgreeTermsFinal = useAppSelector(getTerms);
  const imageUrl = useAppSelector(selectImageUrl);
  const selectedLanguage = useAppSelector(selectLanguage);
  const { firstName, firstNameHebrew } = useAppSelector(getUserDetails);
  const userPermission = useAppSelector(getUserPermission);

  const handleTerms = (e) => {
    setIsAgreeTerms(e.target.checked);
  };
  const handleMarketing = (e) => {
    setIsAgreeMarketing(e.target.checked);
  };

  const handleSubmit = (e) => {
    const data: any = { terms: isAgreeTerms, marketing: isAgreeMarketing };
    dispatch(setContactApprovals(data));
  };

  useEffect(() => {
    if (isAgreeTermsFinal) {
      navigate(`/${pagesEnum.DASHBOARD}`);
    }
  }, [isAgreeTermsFinal]);

  useEffect(() => {
    dispatch(toggleLang('he'));
  }, []);

  return (
    <NoSideBarPage>
      <Stack
        spacing={2}
        sx={{
          padding: '24px',
          flex: 1,
          [theme.breakpoints.down('sm')]: {
            padding: 0,
            background: theme.palette.root.brandSecondary_015,
          },
        }}
      >
        <ColoredArea
          styleObj={{
            flex: 1,
            background: theme.palette.root.brandSecondary_012,
            display: 'flex',
            justifyContent: 'space-between',
            [theme.breakpoints.down('sm')]: {
              padding: '0!important',
              flexDirection: 'column-reverse',
              alignItems: 'center',
              background: 'none',
            },
          }}
        >
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
                justifyContent: 'unset',
                height: 'fit-content',
                width: '100%',
                padding: '0 24px',
              },
            }}
          >
            <Box>
              <Typography variant="h3">
                {t(`${prefixField}header.title`)},{' '}
                {getUserName(firstName, firstNameHebrew, selectedLanguage)}
              </Typography>
              <Typography display="block" variant="body3">
                {t(prefixField + 'header.text')}
              </Typography>
              {/*!isMobile && (
                <Typography variant="body3">{t(prefixField + 'select_plan.text')}</Typography>
              )*/}
            </Box>
            <Box sx={{ marginTop: '48px', [theme.breakpoints.down('sm')]: { marginTop: '28px' } }}>
              <FormHeadWithCheckbox>
                <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                  <Checkbox
                    sx={{ padding: 0, alignItems: 'start' }}
                    onChange={handleTerms}
                    checked={isAgreeTerms}
                  />
                  <FormLabel sx={{ marginLeft: '8px', textAlign: 'left' }}>
                    {t(`${prefixField}terms.text`)}{' '}
                    <Link to={'/' + pagesEnum.TERMS} style={{ color: 'inherit' }}>
                      {t(`${prefixField}terms.link.text`)}
                    </Link>
                    <> & </>
                    <Link to="https://www.as-invest.co.il/about/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA-%D7%94%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA-%D7%91%D7%90%D7%AA%D7%A8%D7%99-%D7%90%D7%9C%D7%98%D7%A9%D7%95%D7%9C%D7%A8-%D7%A9%D7%97%D7%9D/" target="_blank" style={{ color: 'inherit' }}>
                      {t(`${prefixField}privacy.link.text`)}
                    </Link>
                  </FormLabel>
                </Box>
              </FormHeadWithCheckbox>
              <Box sx={{ marginTop: '8px' }}>
                <FormHeadWithCheckbox>
                  <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                    <Checkbox
                      sx={{ padding: 0, alignItems: 'start' }}
                      onChange={handleMarketing}
                      checked={isAgreeMarketing}
                    />
                    <FormLabel sx={{ marginLeft: '8px', textAlign: 'left' }}>
                      {t(`${prefixField}marketing.text`)}
                    </FormLabel>
                  </Box>
                </FormHeadWithCheckbox>
              </Box>

              {isMobile && (
                <Typography
                  sx={{ [theme.breakpoints.down('sm')]: { marginTop: '48px' }, display: 'block' }}
                  variant="body3"
                >
                  {[UserPermission.SIGNER].includes(userPermission) ? t(prefixField + 'select_plan.text') : t(prefixField + 'continue_button.text')}
                </Typography>
              )}
              <Button
                variant="contained"
                sx={{
                  width: '212px',
                  height: '56px',
                  padding: '20px 48px',
                  marginTop: '48px',
                  [theme.breakpoints.down('sm')]: { width: '100%', marginTop: '5px' },
                }}
                disabled={!isAgreeTerms}
                onClick={handleSubmit}
              >
                {[UserPermission.SIGNER].includes(userPermission) ?
                  t(prefixField + 'see_plans_button.text') :
                  t(prefixField + 'continue_button.text')}
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              width: '50%',
              borderRadius: '8px',
              position: 'relative',
              overflow: 'hidden',
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                height: '294px',
                borderRadius: 0,
                marginBottom: '32px',
              },
            }}
          >
            <img
              src={imageUrl('page.dashboard.banner.image')}
              style={{ position: 'absolute', height: '100%', right: 0, borderRadius: '8px' }}
            />
          </Box>
        </ColoredArea>
        <Articles theme='green' />
      </Stack>
    </NoSideBarPage>
  );
}
